module.exports = __webpack_public_path__ + "static/media/1_A1_11.30d95538.png";